import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ReactMarkdown from 'react-markdown';

import { resolveMediaUrl } from '../utils/media';
import { markdownToExcerpt } from '../utils/text';
import { usePageTexts } from '../utils/productI18n';
import { useT } from '../i18n';
import Seo from './Seo';

const PageContent = ({ url }) => {
  const t = useT('page-content');
  // Textes de la page traduits (fichier statique /i18n/pages/<langue>.json), ou null : on affiche alors le français de la base.
  const translated = usePageTexts(url);
  // Page telle que la base la renvoie (français). Les textes affichés en sont dérivés au rendu, pour suivre la langue.
  const [pageData, setPageData] = useState(null);

  // Fetch the content based on the URL
  useEffect(() => {
    axios
      .get('https://joli-mot.fr/api-2026.php', {
        params: { 
          cleApi: '34KVHFQSP226YTk4n256QP6rGbqhA5w2ymY7W3pLwdbuc3i75',
          service: 'getPageByUrl',
          url: url
        }
      })
      .then(response => {
        setPageData(response.data.data);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du contenu de la page !', error);
      });
  }, [url]); // Exécuter lorsque l'URL change

  const pageContent = (translated && translated.contenu) || (pageData ? pageData.contenu : '');
  const pageTitle = (translated && translated.titre) || (pageData ? pageData.titre : '');
  const featuredImage = pageData && pageData.featured_image ? pageData.featured_image : null;
  // Données SEO (titre et description de la page) : la traduction si elle existe, sinon le français de la base.
  const seoData = pageData ? {
    seo_title: (translated && (translated.meta_title || translated.titre)) || pageData.meta_title || pageData.titre || t('page-content.defaultTitle'),
    // Sans description saisie dans l'admin : le début du contenu de la page.
    seo_desc: (translated && (translated.meta_description || markdownToExcerpt(translated.contenu, 155)))
      || pageData.meta_description || markdownToExcerpt(pageData.contenu, 155) || pageData.titre,
  } : { seo_title: '', seo_desc: '' };

  return (
    <Box sx={{ padding: 3, position: 'relative' }}>
      {/* SEO Helmet */}
      {seoData.seo_title && <Seo titre={seoData.seo_title} description={seoData.seo_desc} path={`/${url}`} />}

      <Typography variant="h1" sx={{ marginBottom: 4, textAlign: 'center' }}>
        {pageTitle}
      </Typography>

      {featuredImage && (
        <img
          src={resolveMediaUrl(featuredImage)}
          alt={t('page-content.featuredImageAlt')}
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '150px',
            height: '150px',
            objectFit: 'cover',
            borderRadius: '50%',
            margin: '10px'
          }}
        />
      )}

      {/* Affiche le contenu récupéré */}
      <Box sx={{ marginTop: 5 }}>
        <ReactMarkdown
          components={{
            // Le titre de la page est déjà le <h1> : un « # » du contenu devient un <h2>.
            h1: ({ node, ...props }) => <h2 {...props} />,
            img: ({ node, src, alt, ...props }) => (
              <img src={resolveMediaUrl(src)} alt={alt || ''} {...props} />
            ),
          }}
        >
          {pageContent}
        </ReactMarkdown>
      </Box>
    </Box>
  );
};

export default PageContent;
